import { useEffect } from "react";
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BreadCrumb } from "../../../components/Landing/Breadcrumb/breadcrumb.view";
import { Information } from "./components/Information/Information";
import { Footer } from "../../../components/Landing/Footer";
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";
import { useLanding } from "../../../hooks/useLanding";
import { useParams } from "react-router-dom";
import { BannerTwo } from "./components/Banner/BannerTwo";
import Spinner from "../../../components/Spinner";

export const VerConvocatoriasTwo = () => {
  let { id } = useParams();
  const { convocatoria, getConvocatoriaId } = UseVerConvocatorias();
  const { getConvocatorias, loadingConvocatorias } = useLanding();

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getConvocatoriaId(Number(id));
      getConvocatorias();
    }
    return () => {
      mounted = false;
    };
  }, [id]);

  const routes = [
    { icon: <></>, nombre: "Alcaldía de Medellín" },
    { icon: <></>, nombre: "Secretaría de Cultura Ciudadana" },
    { icon: <></>, nombre: "Convocatoria de Fomento y Estímulos para el Arte y la Cultura" },
    { icon: <></>, nombre: `${convocatoria.nombre_convocatoria}` },
  ];

  if (loadingConvocatorias) {
    return (
      <Spinner loading={loadingConvocatorias} />
    )
  }

  return (
    <>
      <Header />
      <BreadCrumb routes={routes} />
      <BannerTwo convocatorias={convocatoria} />
      <Information convocatorias={convocatoria} />
      <Footer />
    </>
  );
};
